import React, { lazy, Suspense, useState } from "react";
import { Loader } from "semantic-ui-react";
import Header from 'xAppLib/UIelems/Header'
import SideMenu from 'xAppLib/MenuNav/SideMenu'
import LegacyISFooter from 'xAppLib/UIelems/Footer'
import Confirm from 'xAppLib/UIelems/Confirm'
import { Spotlight } from "@iscr/views/UIelems/Spotlight";

import Popups from 'xAppLib/UIelems/Popups'
import withSuspense from "xAppLib/libs/withSuspense";


const IdleScreen = withSuspense(lazy(() => import('views/UIelems/IdleScreen')))

import Routes, { ProfileRoute } from "./Routes";
import Troubleshoot from 'views/UIelems/Troubleshoot'
import SupportActions from 'views/UIelems/SupportActions'
import AuditExpirationBanner from "./views/UIelems/AuditExpirationBanner";
import Alert from "views/NUI/Alert";
import AwaitingConsults from "./views/instcons/AwaitingConsults";
const Watchers = withSuspense(lazy(_=>import('views/instcons/Watchers')))

import { AssertiveRtdbBounce } from "./views/instcons/AssertiveRtdbBounce";
import { HandleMultiFactorAuthentication } from "./xAppLib/UIelems/HandleMultiFactorAuthentication";
import SMSVerification from "./xAppLib/UIelems/SMSVerification";

import ConsultWaitTimeIndicator from "@iscr/components/ConsultWaitTimeIndicator";
import IcosmSideMenu, { MENU_WIDTH } from "./views/icosm/menu/IcosmSideMenu";
import { cls } from "./views/NUI/utils";
import StayOnline from "xAppLib/Users/StayOnline";
import IS2Footer from "./views/UIelems/v2/footer/Footer";

// import { FirebaseDynamicLinks } from '@ionic-native/firebase-dynamic-links';

import CommonAlerts from "./xAppLib/UIelems/CommonAlerts";
import OnboardingNeeded from "@iscr/views/pages/OnboardingNeeded";
import {AppUpdateNudgeBanner} from "@iscr/xAppLib/context/AppUpdateNudgeContext";
import { DeviceRegistrationChangeToast } from "./views/icosm/components/DeviceRegistrationChangeToast";
import { UserPubSub } from "./components/UserPubSub";
import { KioskModeActions } from "@iscr/views/UIelems/KioskModeActions";

export default class Page extends React.Component {

	constructor (props) {
		super(props)
		this.state = {
			user: null
		}

	}
	
	componentDidMount() {
		
		if (app.settings.is_ionic) {
			document.body.classList.add('ionic')
		}

		setTimeout( _=> this.setState({show_hrs_close:true}), 20*1000)

		// Force update to refresh the value of app.acl.is_blocked
		app.on(app.events.CONSENT_UPD, () => this.forceUpdate());

		app.settings.icosm && app.on(app.events.USER_UPD, () => this.setState({ user: {...app.user},}))
		
	}

	//	------------------------	------------------------	------------------------


	renderAppServiceComponents() {
		// These should probably be context providers since they're not rendering anything, rather setting up
		// subscriptions (e.g. watch approvals etc.), or app event listeners (e.g. multifactor auth)
		return (
			<>
				<HandleMultiFactorAuthentication />
				{!app.acl.is_blocked && <>
					{app.acl.is_nurse && (
						<>
							<Suspense fallback={<div className="suspense-style"><Loader active inline/></div>}>
								<AwaitingConsults />
							</Suspense>
							<UserPubSub />
						</>
					)}
					<Watchers />
					<StayOnline />
					<AssertiveRtdbBounce />
				</>}
			</>
		);
	}

	//	------------------------	------------------------	------------------------

	render() {

		const now_open = app.settings.now_open;

		const isCosmLayout = !app.acl.is_blocked && app.settings.icosm && !app.acl.is_usr && !app.acl.is_admin && !app.acl.is_supp && !(app.acl.is_doc && !app.acl.is_NP);

		return  <React.Fragment>

					<div id='page-wrap'>
                        <AppUpdateNudgeBanner/>
						{app.acl.is_nurse && <DeviceRegistrationChangeToast />}
						{app.acl.can_spotlight_search && <Spotlight/>}
						<HeadWithSideMenuMaybe />
						
						<main>

							{/*!this.state.show_hrs_close && !app.acl.is_work && app.dvc?.org?.type!='cosm' && !app.settings.is_cmg && !app.settings.icosm && !app.settings.iprep  &&
								<Message
									header={<center><b>Now {now_open ? 'Open' : 'Closed'}</b></center>}
									content={<center>
												
												{now_open ?
													moment.tz("03:00:00", "H:m:s", "Australia/Melbourne").add(1,'days').diff(moment(), 'hours')<2 && moment.tz("03:00:00", "H:m:s", "Australia/Melbourne").add(1,'days').diff(moment(), 'hours')>=0 && `Closing in ${moment.tz("03:00:00", "H:m:s", "Australia/Melbourne").add(1,'days').diff(moment(), 'hours')} hours ${moment.tz("03:00:00", "H:m:s", "Australia/Melbourne").add(1,'days').diff(moment(), 'minutes')%60} minutes.`
													: `Opening in ${moment.tz("06:00:00", "H:m:s", "Australia/Melbourne").add(1,'days').diff(moment(), 'hours')} hours ${moment.tz("06:00:00", "H:m:s", "Australia/Melbourne").add(1,'days').diff(moment(), 'minutes')%60} minutes.`}
											</center>}
									positive={now_open}
									negative={!now_open}
									onDismiss={_=>this.setState({show_hrs_close:true})}
									floating
									style={{fontSize:'.9em',boxShadow:'none',borderRadius:0, marginLeft:23, marginRight:23}}
							/>*/}

							{app.site_status?.wr_stat?.prediction?.data?.pc_98_wait<=60 && app.dvc?.org?.type!='cosm' && !app.settings.is_cmg && !app.settings.icosm && !app.settings.iprep && !app.settings.iscr2 &&
								<center><ConsultWaitTimeIndicator basic hideIcon color="bg-is-green-20"/></center> 
							}

							{ app.user.user_in && app.settings.ileg && !app.acl.is_leg_firm && <Alert 
								content={"Your firm account is pending verification. You will be notified when it has been reviewed."} 
								warning 
								className='text-center'
							/>}

							{this.renderAppServiceComponents()}

							{!isCosmLayout && !(location.pathname === '/' && app.settings.iscr2) && <CommonAlerts />}

								{isCosmLayout &&
									<div className="w-full flex items-start bg-icosm-secondary divide-x divide-icosm-primary h-full">
										<div className={cls(`page-cont pb-6 w-full h-full`, !app.user.user_in? 'no-user' :'user')} style={{width: app.user.user_in ? `calc(100% - ${MENU_WIDTH})` : "100%"}}
										>
											<CommonAlerts />
											<AuditExpirationBanner />
											<Routes />
										</div>
										<div
											style={{width: MENU_WIDTH}}
											className={`hidden ${
												this.state.user?.user_in && !app.acl.is_admin && !app.acl.is_supp && !(app.acl.is_doc && !app.acl.is_NP) && 'xl:flex'
											} sidemenu sticky top-11 right-0 flex flex-col shrink-0 bg-icosm-quaternary h-screen px-[49px] py-[44px] text-icosm-primary overflow-y-scroll`}
											>
											<IcosmSideMenu />
										</div>									
									</div> 
									|| !app.acl.is_blocked && <Routes />
									|| app.user.is_mfa_blocked && <ProfileRoute />
									|| app.acl.is_blocked && app.settings.iscr2 && <OnboardingNeeded />
								}
							<Troubleshoot />
						</main>
						
						<SupportActions/>
						<KioskModeActions/>

						{app.settings.iscr2 ? !['/signup', '/login', '/create'].includes(location.pathname) && <IS2Footer /> : <LegacyISFooter />}


					</div>
					
					<Popups />
					{ app.state.loaded && app.dvc.org.type=='pharm' && !document.location.href.startsWith('http://localhost:9011/') && 
						<IdleScreen /> 
					}
					<Confirm/>
					<SMSVerification />

				</React.Fragment>

	}

}

const HeadWithSideMenuMaybe = () => {
	const [showMenu, setShowMenu] = useState(false);
	return (
		<>
			{!app.settings.is_bare && <SideMenu showMenu={showMenu} onMenuChange={setShowMenu} />}
			<Header onToggleMenu={setShowMenu} showMenu={showMenu} />
		</>
	);
};